
export const text = `[ID: A photo of some ducks. They are swimming along in a lake. It appears to be a family; several ducklings follow behind.]



`